export default "__VITE_ASSET__DaugcRRf__"